module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Pengaturan Iklan")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pengaturan Iklan")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Status Ads")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "btn-group btn-toggle"
  }, [_c('button', {
    class: _vm.adsStatus ?
      'btn btn-xs btn-success active' :
      'btn btn-xs btn-default',
    on: {
      "click": function($event) {
        _vm.adsStatus = true
      }
    }
  }, [_vm._v("\n                        ON\n                      ")]), _vm._v(" "), _c('button', {
    class: !_vm.adsStatus ?
      'btn btn-xs btn-danger active' :
      'btn btn-xs btn-default',
    on: {
      "click": function($event) {
        _vm.adsStatus = false
      }
    }
  }, [_vm._v("\n                        OFF\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "padding-top": "18px"
    }
  }, [_vm._v("Trigger Ads")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_vm._v("\n                      Minimum Soal\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minQ),
      expression: "minQ"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.minQ)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minQ = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("\n                      Maximum Soal\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxQ),
      expression: "maxQ"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.maxQ)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxQ = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('h4', [_vm._v("Google Ads")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Target Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-selecting dropdown-toggle",
    staticStyle: {
      "padding": "10px",
      "display": "flex",
      "align-items": "center",
      "background": "white",
      "border": "solid 1px lightgray"
    },
    attrs: {
      "type": "button",
      "id": "dropdownMenu2",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Pilih Kelas")]), _vm._v(" "), (_vm.googleTargeted.length > 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "wrap"
    }
  }, _vm._l((_vm.googleTargeted), function(item, i) {
    return _c('span', {
      key: item + 'a',
      staticStyle: {
        "color": "white",
        "border-radius": "4px",
        "padding": "5px",
        "background": "gray",
        "border": "gray solid 1px",
        "margin": "4px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.googleTargeted.splice(i, 1)
        }
      }
    }, [_vm._v("\n                            Kelas " + _vm._s(item) + " "), _c('i', {
      staticClass: "fa fa-close"
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.googleTargeted.length == 0) ? _c('span', {
    staticClass: "caret"
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu2"
    }
  }, _vm._l((_vm.listKelas), function(item) {
    return _c('div', {
      key: item,
      on: {
        "click": function($event) {
          return _vm.googleTargeted.push(item)
        }
      }
    }, [(_vm.hideClass(item, _vm.googleTargeted)) ? _c('li', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('a', [_vm._v("Kelas " + _vm._s(item))])]) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "font-weight": "bold",
      "margin": "10px"
    }
  }, [_vm._v("Tekan untuk menyimpan semua perubahan data!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-large",
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                Simpan\n              ")])])]), _vm._v(" "), _c('h4', [_vm._v("Internal Ads")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.mInternalAdsData), function(d, i) {
    return _c('div', {
      key: i,
      staticClass: "row",
      staticStyle: {
        "padding": "10px 0px 10px 0px",
        "border-bottom": "1px solid lightgray"
      }
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-selecting dropdown-toggle",
      staticStyle: {
        "padding": "10px",
        "display": "flex",
        "align-items": "center",
        "background": "white",
        "border": "solid 1px lightgray",
        "flex-flow": "column"
      },
      attrs: {
        "type": "button",
        "id": "dropdownMenu2",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v("Pilih Kelas")]), _vm._v(" "), (d.grades.length > 0) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap"
      }
    }, _vm._l((d.grades), function(item, it) {
      return _c('button', {
        key: item + 'a',
        staticStyle: {
          "color": "white",
          "border-radius": "4px",
          "padding": "5px",
          "background": "gray",
          "border": "gray solid 1px",
          "margin": "4px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeGrade(i, it)
          }
        }
      }, [_vm._v("\n                        Kelas " + _vm._s(item) + " "), _c('i', {
        staticClass: "fa fa-close"
      })])
    }), 0) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "aria-labelledby": "dropdownMenu2"
      }
    }, _vm._l((_vm.listKelas), function(item) {
      return _c('div', {
        key: item,
        on: {
          "click": function($event) {
            return _vm.addGrade(i, item)
          }
        }
      }, [(_vm.hideClass(item, _vm.internalSelectedClass)) ? _c('li', {
        staticStyle: {
          "padding": "10px"
        }
      }, [_c('a', [_vm._v("Kelas " + _vm._s(item))])]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (d.title),
        expression: "d.title"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "220",
        "cols": "30",
        "rows": "5"
      },
      domProps: {
        "value": (d.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(d, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (d.description),
        expression: "d.description"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "",
        "cols": "30",
        "rows": "5"
      },
      domProps: {
        "value": (d.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(d, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column",
        "justify-content": "center"
      }
    }, [_c('input', {
      attrs: {
        "id": "fileUpload",
        "type": "file",
        "hidden": "",
        "accept": "image/*"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), (d.image == '') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.chooseFiles(d, i)
        }
      }
    }, [_vm._v("\n                  Pilih Gambar "), _c('i', {
      staticClass: "fa fa-image"
    })]) : _vm._e(), _vm._v(" "), (d.image !== '') ? _c('img', {
      staticStyle: {
        "height": "100px"
      },
      attrs: {
        "src": d.image + '?rnd=' + Math.random(1231231)
      }
    }) : _vm._e(), _vm._v(" "), (d.image !== '') ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      staticStyle: {
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.mInternalAdsData[i].image = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "flex-flow": "row"
      }
    }, [_c('button', {
      staticClass: "btn btn-success btn-xl",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.saveInternalSetting(d, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    })]), _vm._v(" "), (i + 1 !== _vm.mInternalAdsData.length) ? _c('button', {
      staticClass: "btn btn-danger btn-xl",
      on: {
        "click": function($event) {
          return _vm.deleteAds(d.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2)])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Pengaturan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h5', [_vm._v("Kelas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Judul")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Deskripsi")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h5', [_vm._v("Image")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0a0ccda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/iklan/Form.vue
// module id = 1386
// module chunks = 0